import Image from "next/image";
import { AssetFields } from "contentful";

interface ContentImageProps {
  width?: number;
  fields: AssetFields;
  className?: string;
}

export function ContentImage({ width, fields, className }: ContentImageProps) {
  if (!fields.file?.details.image) return <></>;

  const { width: originalWidth, height: originalHeight } =
    fields.file?.details.image;
  const ratio = originalWidth / originalHeight;
  const newWidth = width || 200;
  const newHeight = newWidth / ratio;

  // eslint-disable-next-line jsx-a11y/alt-text
  return (
    <Image
      className={className}
      src={`https:${fields.file.url}`}
      alt={fields.title ?? ""}
      width={newWidth}
      height={newHeight}
      sizes={"(max-width: 768px) 100vw, 33vw"}
    />
  );
}
